(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadCreateIbPurchService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 736,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 737,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
